// extracted by mini-css-extract-plugin
export var BtnV2 = "analytics-module--BtnV2--6a8fe";
export var BtnV2Black = "analytics-module--BtnV2--black--8f007";
export var BtnV2Borderless = "analytics-module--BtnV2--borderless--0c6ff";
export var BtnV2Cloud = "analytics-module--BtnV2--cloud--6eec0";
export var BtnV2Disabled = "analytics-module--BtnV2--disabled--f9206";
export var BtnV2Focusable = "analytics-module--BtnV2--focusable--792c4";
export var BtnV2Fullwidth = "analytics-module--BtnV2--fullwidth--4749f";
export var BtnV2Gold = "analytics-module--BtnV2--gold--1a014";
export var BtnV2Grey = "analytics-module--BtnV2--grey--1f230";
export var BtnV2Icon = "analytics-module--BtnV2--icon--e4d54";
export var BtnV2Lg = "analytics-module--BtnV2--lg--a3073";
export var BtnV2Midnight = "analytics-module--BtnV2--midnight--1f547";
export var BtnV2Multiline = "analytics-module--BtnV2--multiline--4bd78";
export var BtnV2Nofocus = "analytics-module--BtnV2--nofocus--81ef7";
export var BtnV2Secondary = "analytics-module--BtnV2--secondary--1b10c";
export var BtnV2Sm = "analytics-module--BtnV2--sm--ad7f6";
export var BtnV2Solid = "analytics-module--BtnV2--solid--9590f";
export var BtnV2Square = "analytics-module--BtnV2--square--ad735";
export var BtnV2Success = "analytics-module--BtnV2--success--2875b";
export var BtnV2Text = "analytics-module--BtnV2--text--75729";
export var BtnV2Warning = "analytics-module--BtnV2--warning--58116";
export var BtnV2White = "analytics-module--BtnV2--white--4738d";
export var BtnV2Xl = "analytics-module--BtnV2--xl--629f8";
export var BtnV2Yellow = "analytics-module--BtnV2--yellow--74903";
export var ColorBlock = "analytics-module--ColorBlock--a4286";
export var ColorBlockColorGrey = "analytics-module--ColorBlock--colorGrey--e83a1";
export var ColorBlockGrey = "analytics-module--ColorBlock--grey--8ce0d";
export var ColorBlockMidGrey = "analytics-module--ColorBlock--midGrey--a667c";
export var ColorBlockPink = "analytics-module--ColorBlock--pink--1959f";
export var ColorBlockPrimary = "analytics-module--ColorBlock--primary--33423";
export var ColorBlockPrimaryDark = "analytics-module--ColorBlock--primaryDark--86e00";
export var ColorBlockPrimaryLight = "analytics-module--ColorBlock--primaryLight--29b81";
export var ColorBlockPrimaryMid = "analytics-module--ColorBlock--primaryMid--02800";
export var ColorBlockPurple = "analytics-module--ColorBlock--purple--06aed";
export var ColorBlockRed = "analytics-module--ColorBlock--red--36b4f";
export var ColorBlockSecondary = "analytics-module--ColorBlock--secondary--fbe2c";
export var ColorBlockSecondaryDark = "analytics-module--ColorBlock--secondaryDark--4bbec";
export var ColorBlockSecondaryLight = "analytics-module--ColorBlock--secondaryLight--78912";
export var ColorBlockSecondaryMid = "analytics-module--ColorBlock--secondaryMid--572bb";
export var ColorBlockText = "analytics-module--ColorBlock--text--9a962";
export var ColorBlockYellow = "analytics-module--ColorBlock--yellow--2918c";
export var ColorBlocks = "analytics-module--ColorBlocks--5f664";
export var DashboardTopoptions = "analytics-module--Dashboard--topoptions--f5b11";
export var HideEmbedded = "analytics-module--HideEmbedded--8089a";
export var ShowEmbedded = "analytics-module--ShowEmbedded--3aa40";
export var Template__descriptionContent = "analytics-module--Template__description-content--00f72";
export var __active = "analytics-module--__active--484f1";
export var __custom = "analytics-module--__custom--94b16";
export var _pin = "analytics-module--_pin--d70a6";
export var _pinText = "analytics-module--_pinText--e1a8f";
export var aliceCarousel__dots = "analytics-module--alice-carousel__dots--867a6";
export var aliceCarousel__dotsItem = "analytics-module--alice-carousel__dots-item--c4710";
export var btnGroup = "analytics-module--btn-group--b67ba";
export var ccCompliance = "analytics-module--cc-compliance--5688a";
export var h1 = "analytics-module--h1--d38a9";
export var h2 = "analytics-module--h2--21183";
export var h3 = "analytics-module--h3--8e958";
export var h4 = "analytics-module--h4--a8cd5";
export var link = "analytics-module--link--e1520";
export var maxWidth = "analytics-module--max-width--aaf00";
export var menuOpen = "analytics-module--menu-open--44525";
export var noChildPMb = "analytics-module--no-child-p-mb--91364";
export var nobar = "analytics-module--nobar--f9062";
export var p1 = "analytics-module--p1--31aed";
export var p2 = "analytics-module--p2--71a8a";
export var path1 = "analytics-module--path1--bee42";
export var path2 = "analytics-module--path2--950a0";
export var pin = "analytics-module--pin--90ced";
export var seogroup = "analytics-module--seogroup--de0f2";